window.addEventListener('load', function() {
  function applyCustomStyles() {
    var style = document.createElement('style');
    style.innerHTML = `
      .pr-reviewsnippet, .pr-reviewdisplay, .pr-irlsnippet {
        max-width: 100% !important;
        margin: 0 auto !important;
        text-align: center !important;
      }

      .pr-stars, .pr-rating-count {
        display: inline-block !important;
        font-size: 1.2em !important;
      }

      @media (max-width: 768px) {
        .pr-stars, .pr-rating-count {
          font-size: 1em !important;
        }
      }

      @media (max-width: 480px) {
        .pr-stars, .pr-rating-count {
          font-size: 0.8em !important;
        }
      }

      /* Additional styles to ensure the container is flexible */
      .product-card {
        display: flex;
        flex-direction: column;
        height: auto !important;
        overflow: visible !important;
      }

      .product-card .product-featured-image,
      .product-card .product-card-info {
        flex: 1 1 auto;
        height: auto !important;
        overflow: visible !important;
      }
    `;
    document.head.appendChild(style);
  }

  function forceRepaint() {
    var evt = window.document.createEvent('UIEvents'); 
    evt.initUIEvent('resize', true, false, window, 0); 
    window.dispatchEvent(evt);
  }

  // Apply styles immediately after the full load
  applyCustomStyles();
  forceRepaint();

  // Reapply styles and force repaint after PowerReviews are rendered
  document.addEventListener('PowerReviewsLoaded', function() {
    applyCustomStyles();
    forceRepaint();
  }, false);
});

(function () {
  var STORAGE_KEY = 'moPreferredShowroom';
  var stores = {
    'nicholasville-road': {
      label: 'Lexington / Nicholasville Road',
      shortLabel: 'Lexington',
      url: '/pages/mattress-store-lexington-ky',
      lat: 37.9778749,
      lon: -84.529193,
      aliases: ['mattress-overstock-nicholasville-road', 'mattress-overstock-lexington-ky', 'mattress-store-lexington-ky']
    },
    richmond: {
      label: 'Richmond',
      shortLabel: 'Richmond',
      url: '/pages/mattress-overstock-richmond-ky',
      lat: 37.7361924,
      lon: -84.3064799,
      aliases: ['mattress-overstock-richmond-ky']
    },
    georgetown: {
      label: 'Georgetown',
      shortLabel: 'Georgetown',
      url: '/pages/mattress-overstock-georgetown-ky',
      lat: 38.1894016,
      lon: -84.5622319,
      aliases: ['mattress-overstock-georgetown-ky']
    },
    london: {
      label: 'London',
      shortLabel: 'London',
      url: '/pages/mattress-overstock-london-ky',
      lat: 37.1119026,
      lon: -84.0658445,
      aliases: ['mattress-overstock-london-ky']
    },
    somerset: {
      label: 'Somerset',
      shortLabel: 'Somerset',
      url: '/pages/mattress-overstock-somerset-ky',
      lat: 37.05,
      lon: -84.629,
      aliases: ['mattress-overstock-somerset-ky']
    }
  };
  var aliasToKey = {};
  Object.keys(stores).forEach(function (key) {
    aliasToKey[key] = key;
    stores[key].aliases.forEach(function (alias) {
      aliasToKey[alias] = key;
    });
  });
  // Your store (2026-10-01): snippets/mo-your-store.liquid carries one data island with each
  // store's address, map link, coordinates and the shared hours. It overrides the table above.
  var showroomData = { hours: '', hoursText: '', hoursNote: '', auto: false, autoAsk: false, radius: 60 };
  (function () {
    var island = document.querySelector('[data-mo-showrooms]');
    if (!island) return;
    try {
      var data = JSON.parse(island.textContent);
      showroomData.hours = data.hours || '';
      showroomData.hoursText = data.hoursText || '';
      showroomData.hoursNote = data.hoursNote || '';
      showroomData.auto = data.auto === true;
      showroomData.autoAsk = data.autoAsk === true;
      if (typeof data.radius === 'number' && data.radius > 0) showroomData.radius = data.radius;
      (data.stores || []).forEach(function (item) {
        var store = stores[item.key];
        if (!store) return;
        if (item.name) store.shortLabel = item.name;
        if (item.url) store.url = item.url;
        if (typeof item.lat === 'number') store.lat = item.lat;
        if (typeof item.lon === 'number') store.lon = item.lon;
        store.street = item.street || '';
        store.city = item.city || '';
        store.zip = item.zip || '';
        store.map = item.map || '';
      });
    } catch (error) {}
  })();
  // Write only when the value changes. The body MutationObserver below re-runs these updaters on
  // every DOM change, so an unconditional write would retrigger it forever.
  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }
  function track(name, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      Object.keys(data || {}).forEach(function (k) { payload[k] = data[k]; });
      window.dataLayer.push(payload);
    } catch (error) {}
  }
  function parseKeys(value) {
    if (!value) return [];
    return value.split(',').map(function (key) { return key.trim(); }).filter(function (key) { return stores[key]; });
  }
  function keyFromValue(value) {
    if (!value) return '';
    return aliasToKey[String(value).trim().toLowerCase()] || '';
  }
  function keyFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var paramKey = keyFromValue(params.get('mo_showroom') || params.get('showroom') || params.get('store'));
    if (paramKey) return paramKey;
    var handle = window.location.pathname.split('/').filter(Boolean).pop();
    return keyFromValue(handle);
  }
  function storedKey() {
    try {
      return keyFromValue(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      return '';
    }
  }
  function saveKey(key) {
    try {
      window.localStorage.setItem(STORAGE_KEY, key);
    } catch (error) {}
    clearAuto();
  }
  function distanceMiles(aLat, aLon, bLat, bLon) {
    var r = 3958.8;
    var toRad = Math.PI / 180;
    var dLat = (bLat - aLat) * toRad;
    var dLon = (bLon - aLon) * toRad;
    var lat1 = aLat * toRad;
    var lat2 = bLat * toRad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return 2 * r * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
  }
  function nearestFromPoint(lat, lon, candidateKeys) {
    var bestKey = '';
    var bestDistance = Infinity;
    candidateKeys.forEach(function (key) {
      var store = stores[key];
      if (!store) return;
      var miles = distanceMiles(lat, lon, store.lat, store.lon);
      if (miles < bestDistance) {
        bestDistance = miles;
        bestKey = key;
      }
    });
    return bestKey;
  }
  function nearestFromStore(selectedKey, candidateKeys) {
    if (!candidateKeys.length) return '';
    if (selectedKey && candidateKeys.indexOf(selectedKey) !== -1) return selectedKey;
    var selected = stores[selectedKey];
    if (!selected) return candidateKeys[0];
    return nearestFromPoint(selected.lat, selected.lon, candidateKeys);
  }
  function preferredKey() {
    return keyFromUrl() || storedKey() || autoKey;
  }
  function updateCardBadges(selectedKey) {
    document.querySelectorAll('[data-mo-card-tryability]').forEach(function (badge) {
      var label = badge.querySelector('[data-mo-card-tryability-label]');
      if (!label) return;
      if (badge.hasAttribute('data-mo-floor-line')) return;
      var kind = badge.getAttribute('data-mo-card-tryability');
      var candidateKeys = parseKeys(badge.getAttribute('data-mo-showroom-keys'));
      var nearestKey = nearestFromStore(selectedKey, candidateKeys);
      var store = stores[nearestKey];
      if (!store) return;
      if (badge.getAttribute('href') !== store.url) badge.href = store.url;
      badge.setAttribute('data-mo-selected-showroom', nearestKey);
      if (kind === 'exact') {
        setText(label, 'Try in ' + store.shortLabel);
      } else if (kind === 'similar') {
        setText(label, 'Compare similar feel in ' + store.shortLabel);
      } else if (kind === 'confirm') {
        setText(label, 'Ask ' + store.shortLabel + ' about floor display');
      }
    });
  }
  function updatePreferenceBars(selectedKey) {
    var store = stores[selectedKey];
    if (!store) return;
    document.querySelectorAll('[data-mo-showroom-preference-bar]').forEach(function (bar) {
      var status = bar.querySelector('[data-mo-showroom-preference-status]');
      setText(status, 'Using ' + store.label + ' for try-in notes on this collection.');
      bar.querySelectorAll('[data-mo-location-choice]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-mo-location-choice') === selectedKey ? 'true' : 'false');
      });
    });
  }
  function updatePdpModules(selectedKey) {
    document.querySelectorAll('[data-mo-tryability]').forEach(function (module) {
      var exactKeys = parseKeys(module.getAttribute('data-mo-exact-showroom-keys'));
      var similarKeys = parseKeys(module.getAttribute('data-mo-similar-showroom-keys'));
      var confirmKeys = parseKeys(module.getAttribute('data-mo-confirm-showroom-keys'));
      var status = 'exact';
      var candidateKeys = exactKeys;
      if (!candidateKeys.length) {
        status = 'similar';
        candidateKeys = similarKeys;
      }
      if (!candidateKeys.length) {
        status = 'confirm';
        candidateKeys = confirmKeys;
      }
      var nearestKey = nearestFromStore(selectedKey, candidateKeys);
      var store = stores[nearestKey];
      if (!store) return;
      var title = module.querySelector('[data-mo-tryability-title]');
      var body = module.querySelector('[data-mo-tryability-body]');
      var nearest = module.querySelector('[data-mo-tryability-nearest]');
      var nearestTitle = module.querySelector('[data-mo-tryability-nearest-title]');
      var nearestBody = module.querySelector('[data-mo-tryability-nearest-body]');
      var nearestLink = module.querySelector('[data-mo-tryability-nearest-link]');
      if (status === 'exact') {
        setText(title, 'Try this mattress in ' + store.shortLabel);
        setText(body, 'This model is marked for exact floor display at the ' + store.shortLabel + ' showroom. You can still compare the other marked locations below.');
        setText(nearestTitle, 'Closest exact display: ' + store.label);
        setText(nearestBody, 'Start with this showroom, then call ahead if you are driving in for one exact model.');
      } else if (status === 'similar') {
        setText(title, 'Compare a similar feel in ' + store.shortLabel);
        setText(body, 'The ' + store.shortLabel + ' team can help compare the closest available feel and confirm the floor setup.');
        setText(nearestTitle, 'Closest similar-feel help: ' + store.label);
        setText(nearestBody, 'Use the showroom team to narrow pressure, cooling, motion, height, and base fit.');
      } else {
        setText(title, 'Ask ' + store.shortLabel + ' before you drive in');
        setText(body, 'The showroom team can confirm the floor setup and point you toward the closest comparable feel.');
        setText(nearestTitle, 'Closest showroom: ' + store.label);
        setText(nearestBody, 'Call or visit the showroom page before planning the trip around one exact model.');
      }
      if (nearestLink && nearestLink.getAttribute('href') !== store.url) nearestLink.href = store.url;
      if (nearest && nearest.hidden) nearest.hidden = false;
      module.querySelectorAll('[data-showroom-key]').forEach(function (card) {
        var isNearest = card.getAttribute('data-showroom-key') === nearestKey;
        card.classList.toggle('is-mo-nearest', isNearest);
        if (isNearest && card.parentElement && card.parentElement.firstElementChild !== card) {
          card.parentElement.insertBefore(card, card.parentElement.firstElementChild);
        }
      });
      module.querySelectorAll('[data-mo-location-choice]').forEach(function (button) {
        button.setAttribute('aria-pressed', button.getAttribute('data-mo-location-choice') === nearestKey ? 'true' : 'false');
      });
    });
  }
  // ---- Your store: header button and panel (snippets/mo-your-store.liquid) ----
  // Floor display, hours and directions only. No stock or pickup claims.
  function esc(value) {
    return String(value == null ? '' : value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function openStatus() {
    try {
      return window.MOLP && window.MOLP.status ? window.MOLP.status(showroomData.hours) : null;
    } catch (error) {
      return null;
    }
  }
  var PIN_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21s7-6.2 7-11.5A7 7 0 0 0 5 9.5C5 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.4"/></svg>';
  function yourStorePanel(key, store, status, isAuto) {
    var html = '<p class="mo-ys__kicker">Your store</p>';
    if (store) {
      html += '<p class="mo-ys__name">' + esc(store.shortLabel) + '</p>';
      if (status) html += '<p class="mo-ys__open ' + esc(status.cls) + '">' + esc(status.text) + '</p>';
      if (store.street) html += '<p class="mo-ys__addr">' + esc(store.street) + '<br>' + esc(store.city) + ', KY ' + esc(store.zip) + '</p>';
      if (showroomData.hoursText) html += '<p class="mo-ys__hours">' + esc(showroomData.hoursText) + '. ' + esc(showroomData.hoursNote) + '</p>';
      if (isAuto) html += '<p class="mo-ys__auto">Set from your area. Not right? Pick another below, or use your location.</p>';
      html += '<p class="mo-ys__actions">';
      if (store.map) html += '<a href="' + esc(store.map) + '" target="_blank" rel="noopener" data-mo-ys-directions="' + esc(key) + '">' + PIN_ICON + 'Directions</a>';
      html += '<a href="' + esc(store.url) + '" data-mo-ys-store-page="' + esc(key) + '">Store page</a></p>';
    } else {
      html += '<p class="mo-ys__name">Choose a showroom</p>';
      html += '<p class="mo-ys__addr">Pick the store you would visit. Mattress pages then say what is on that floor, and this menu shows when it is open.</p>';
    }
    html += '<hr class="mo-ys__rule"><p class="mo-ys__head"><span>' + (store ? 'Other showrooms' : 'Five Kentucky showrooms') + '</span>';
    html += '<button type="button" class="mo-ys__geo" data-mo-location-geo>Use my location</button></p><ul class="mo-ys__list">';
    Object.keys(stores).forEach(function (other) {
      if (other === key) return;
      html += '<li><span>' + esc(stores[other].shortLabel) + '</span><button type="button" data-mo-location-choice="' + esc(other) + '">' + (store ? 'Make this my store' : 'Set as my store') + '</button></li>';
    });
    html += '</ul><p class="mo-ys__note">' + (store ? 'Floor models differ by store. No appointment needed.' : esc(showroomData.hoursText) + '. No appointment needed.') + '</p>';
    return html;
  }
  var yourStoreSignature = null;
  function updateYourStore(key) {
    var root = document.querySelector('[data-mo-your-store]');
    if (!root) return;
    var store = stores[key] || null;
    if (!store) key = '';
    var status = store ? openStatus() : null;
    var isAuto = !!key && key === autoKey && !storedKey() && !keyFromUrl();
    var signature = key + '|' + (status ? status.text : '') + '|' + (isAuto ? 'auto' : '');
    if (signature === yourStoreSignature) return;
    yourStoreSignature = signature;
    setText(root.querySelector('[data-mo-ys-label]'), store ? 'Your store: ' + store.shortLabel : 'Choose your store');
    setText(root.querySelector('[data-mo-ys-status]'), status ? status.text : '');
    // The phone strip has its own short label and toggle (snippets/mo-your-store-strip.liquid).
    var announce = store ? 'Your store: ' + store.shortLabel + (status ? '. ' + status.text : '') : 'Choose your store';
    Array.prototype.forEach.call(document.querySelectorAll('[data-mo-ys-name]'), function (el) { setText(el, store ? store.shortLabel : 'Your store'); });
    Array.prototype.forEach.call(document.querySelectorAll('[data-mo-ys-toggle]'), function (el) { el.setAttribute('aria-label', announce); });
    var panel = root.querySelector('[data-mo-ys-panel]');
    if (panel) panel.innerHTML = yourStorePanel(key, store, status, isAuto);
  }
  function setYourStorePanel(open, from) {
    var root = document.querySelector('[data-mo-your-store]');
    if (!root) return;
    var panel = root.querySelector('[data-mo-ys-panel]');
    if (!panel) return;
    if (open && from) root.style.setProperty('--mo-ys-top', Math.round(from.getBoundingClientRect().bottom + 10) + 'px');
    panel.hidden = !open;
    Array.prototype.forEach.call(document.querySelectorAll('[data-mo-ys-toggle]'), function (el) { el.setAttribute('aria-expanded', open ? 'true' : 'false'); });
  }
  var yourStoreOpener = null;
  function bindYourStore() {
    document.addEventListener('click', function (event) {
      var root = document.querySelector('[data-mo-your-store]');
      if (!root) return;
      var panel = root.querySelector('[data-mo-ys-panel]');
      if (!panel) return;
      var toggle = event.target.closest('[data-mo-ys-toggle]');
      if (toggle) {
        yourStoreOpener = toggle;
        hideNudge();
        setYourStorePanel(panel.hidden, toggle);
        return;
      }
      if (event.target.closest('[data-mo-ys-nudge-close]')) {
        hideNudge();
        return;
      }
      if (event.target.closest('[data-mo-ys-nudge-change]')) {
        hideNudge();
        yourStoreOpener = visibleToggle();
        setYourStorePanel(true, yourStoreOpener);
        return;
      }
      var directions = event.target.closest('[data-mo-ys-directions]');
      if (directions) track('mo_store_directions_click', { mo_store: directions.getAttribute('data-mo-ys-directions'), mo_store_surface: 'header' });
      // A click inside the panel can replace its contents, which detaches the target. Only an
      // attached target outside the control closes it.
      if (!panel.hidden && document.documentElement.contains(event.target) && !event.target.closest('[data-mo-your-store]')) setYourStorePanel(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var panel = document.querySelector('[data-mo-ys-panel]');
      if (!panel || panel.hidden) return;
      setYourStorePanel(false);
      if (yourStoreOpener) yourStoreOpener.focus();
    });
    window.setInterval(function () { updateYourStore(preferredKey()); }, 60000);
  }

  // ---- Your store: automatic store (2026-10-01) ----
  // For a visitor with no saved or linked store. Exact location is used only if the browser
  // already allows it (no prompt). Otherwise one approximate-area lookup by internet address.
  // Both run only when Shopify's customer privacy API says preferences may be processed, which is
  // how regions that need consent are respected. The store's cookie banner is off (2026-08-25), so
  // that API allows every visitor; the area lookup therefore also requires a US region, read from
  // the same first-party API. Outside the US, or with no region, no lookup is made. Coordinates are
  // used once in the browser and never stored; only the chosen store key is kept, in sessionStorage.
  var AUTO_KEY = 'moAutoShowroom';
  var NUDGE_SEEN_KEY = 'moStoreNudgeSeen';
  var ASKED_KEY = 'moStoreLocationAsked';
  var AREA_LOOKUP = 'https://get.geojs.io/v1/ip/geo.json';
  var autoKey = '';
  var autoStarted = false;
  var nudgeTimer = null;
  function readSessionAuto() {
    try {
      var raw = window.sessionStorage.getItem(AUTO_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }
  function writeSessionAuto(value) {
    try {
      window.sessionStorage.setItem(AUTO_KEY, JSON.stringify(value));
    } catch (error) {}
  }
  function clearAuto() {
    autoKey = '';
    try {
      window.sessionStorage.removeItem(AUTO_KEY);
    } catch (error) {}
    hideNudge();
  }
  // One-time flags. If storage is blocked, behave as if the flag is set so nothing repeats.
  function flag(name, set) {
    try {
      if (set) {
        window.localStorage.setItem(name, '1');
        return true;
      }
      return window.localStorage.getItem(name) === '1';
    } catch (error) {
      return true;
    }
  }
  function preferencesAllowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.preferencesProcessingAllowed !== 'function') return null;
      return api.preferencesProcessingAllowed() === true;
    } catch (error) {
      return null;
    }
  }
  function visitorRegion() {
    try {
      return String(window.Shopify.customerPrivacy.getRegion() || '');
    } catch (error) {
      return '';
    }
  }
  function visibleToggle() {
    var all = document.querySelectorAll('[data-mo-ys-toggle]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null) return all[i];
    }
    return all[0] || null;
  }
  function locationIfAlreadyAllowed(done) {
    try {
      if (!navigator.geolocation || !navigator.permissions || !navigator.permissions.query) {
        done(null, '');
        return;
      }
      navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
        if (result.state !== 'granted') {
          done(null, result.state);
          return;
        }
        navigator.geolocation.getCurrentPosition(function (position) {
          done({ lat: position.coords.latitude, lon: position.coords.longitude }, 'granted');
        }, function () {
          done(null, 'granted');
        }, { maximumAge: 600000, timeout: 5000, enableHighAccuracy: false });
      }, function () {
        done(null, '');
      });
    } catch (error) {
      done(null, '');
    }
  }
  function lookupArea(done) {
    if (!window.fetch) {
      done(null);
      return;
    }
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 2500);
    window.fetch(AREA_LOOKUP, { credentials: 'omit', referrerPolicy: 'no-referrer', signal: controller ? controller.signal : undefined })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        window.clearTimeout(timer);
        var lat = data ? parseFloat(data.latitude) : NaN;
        var lon = data ? parseFloat(data.longitude) : NaN;
        if (!data || data.country_code !== 'US' || isNaN(lat) || isNaN(lon)) {
          done(null);
          return;
        }
        done({ lat: lat, lon: lon });
      })
      .catch(function () {
        window.clearTimeout(timer);
        done(null);
      });
  }
  function hideNudge() {
    if (nudgeTimer) {
      window.clearTimeout(nudgeTimer);
      nudgeTimer = null;
    }
    var nudge = document.querySelector('[data-mo-ys-nudge]');
    if (nudge && !nudge.hidden) nudge.hidden = true;
  }
  function showNudge(key) {
    var root = document.querySelector('[data-mo-your-store]');
    if (!root || flag(NUDGE_SEEN_KEY)) return;
    flag(NUDGE_SEEN_KEY, true);
    var nudge = root.querySelector('[data-mo-ys-nudge]');
    if (!nudge) {
      nudge = document.createElement('div');
      nudge.className = 'mo-ys__nudge';
      nudge.setAttribute('data-mo-ys-nudge', '');
      nudge.setAttribute('role', 'status');
      nudge.hidden = true;
      root.appendChild(nudge);
    }
    var store = stores[key];
    nudge.innerHTML = '<button type="button" class="mo-ys__nudge-close" data-mo-ys-nudge-close aria-label="Dismiss">&times;</button>' +
      (store
        ? '<p><b>Your store is set to ' + esc(store.shortLabel) + '.</b> That is a best guess from your area.</p>'
        : '<p><b>Find your nearest showroom.</b> Five in Kentucky, no appointment needed.</p>') +
      '<div class="mo-ys__nudge-actions"><button type="button" data-mo-location-geo>Use my exact location</button>' +
      '<button type="button" data-mo-ys-nudge-change>' + (store ? 'Change store' : 'Choose a store') + '</button></div>';
    var toggle = visibleToggle();
    if (toggle) root.style.setProperty('--mo-ys-top', Math.round(toggle.getBoundingClientRect().bottom + 10) + 'px');
    nudge.hidden = false;
    nudgeTimer = window.setTimeout(hideNudge, 14000);
  }
  // Optional (Theme settings): open the browser's own permission box once, without a tap.
  function askLocationOnce() {
    if (flag(ASKED_KEY)) return;
    flag(ASKED_KEY, true);
    navigator.geolocation.getCurrentPosition(function (position) {
      var key = nearestFromPoint(position.coords.latitude, position.coords.longitude, Object.keys(stores));
      if (!key) return;
      saveKey(key);
      applySelectedShowroom(key);
      track('mo_store_selected', { mo_store: key, mo_store_method: 'location', mo_store_surface: 'auto_prompt' });
    }, function () {}, { maximumAge: 300000, timeout: 8000, enableHighAccuracy: false });
  }
  function finishAuto(point, source, permissionState) {
    if (keyFromUrl() || storedKey()) return;
    var key = '';
    var miles = null;
    if (point) {
      key = nearestFromPoint(point.lat, point.lon, Object.keys(stores));
      miles = key ? distanceMiles(point.lat, point.lon, stores[key].lat, stores[key].lon) : null;
      if (miles === null || miles > showroomData.radius) key = '';
    }
    writeSessionAuto({ key: key, source: source });
    if (key) {
      autoKey = key;
      applySelectedShowroom(key);
      track('mo_store_auto_set', { mo_store: key, mo_store_method: source, mo_store_miles: Math.round(miles) });
    }
    // Offer exact location only to visitors who look local, and never after they refused it.
    var local = !!key || visitorRegion() === 'USKY';
    if (source === 'location' || !local || !navigator.geolocation || permissionState === 'denied') return;
    if (showroomData.autoAsk) {
      askLocationOnce();
    } else {
      showNudge(key);
    }
  }
  function runAuto() {
    if (autoStarted || keyFromUrl() || storedKey()) return;
    autoStarted = true;
    locationIfAlreadyAllowed(function (point, state) {
      if (point) {
        finishAuto(point, 'location', state);
        return;
      }
      if (visitorRegion().slice(0, 2) !== 'US') {
        finishAuto(null, 'area', state);
        return;
      }
      lookupArea(function (areaPoint) {
        finishAuto(areaPoint, 'area', state);
      });
    });
  }
  function autoLocate() {
    if (!showroomData.auto || !document.querySelector('[data-mo-your-store]')) return;
    if (keyFromUrl() || storedKey()) return;
    var cached = readSessionAuto();
    if (cached) {
      if (cached.key && stores[cached.key]) {
        autoKey = cached.key;
        applySelectedShowroom(autoKey);
      }
      return;
    }
    // Wait for Shopify's consent API (up to 5 s). No answer means no lookup.
    var tries = 0;
    (function wait() {
      var allowed = preferencesAllowed();
      if (allowed === null && ++tries <= 20) {
        window.setTimeout(wait, 250);
        return;
      }
      if (allowed === true) runAuto();
    })();
    // Where a consent banner applies, run once the visitor accepts preferences.
    document.addEventListener('visitorConsentCollected', function () {
      if (preferencesAllowed() === true) runAuto();
    });
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      }
    } catch (error) {}
  }

  var reapplyTimer = null;
  var lastAppliedKey = null;
  function applySelectedShowroom(key) {
    if (!key || !stores[key]) {
      updateYourStore('');
      return;
    }
    document.documentElement.setAttribute('data-mo-selected-showroom', key);
    updateCardBadges(key);
    updatePreferenceBars(key);
    updatePdpModules(key);
    updateYourStore(key);
    if (lastAppliedKey !== key) {
      lastAppliedKey = key;
      try {
        document.dispatchEvent(new CustomEvent('mo:showroom-change', { detail: { key: key } }));
      } catch (error) {}
    }
  }
  function scheduleApply() {
    if (reapplyTimer) window.clearTimeout(reapplyTimer);
    reapplyTimer = window.setTimeout(function () {
      applySelectedShowroom(preferredKey());
    }, 80);
  }
  function bindInteractions() {
    document.addEventListener('click', function (event) {
      var choice = event.target.closest('[data-mo-location-choice]');
      if (choice) {
        var key = keyFromValue(choice.getAttribute('data-mo-location-choice'));
        if (key) {
          event.preventDefault();
          var choiceSurface = choice.closest('[data-mo-your-store]') ? 'header' : 'page';
          saveKey(key);
          applySelectedShowroom(key);
          track('mo_store_selected', { mo_store: key, mo_store_method: 'choice', mo_store_surface: choiceSurface });
        }
      }
      var geo = event.target.closest('[data-mo-location-geo]');
      if (geo) {
        event.preventDefault();
        var fromNudge = !!geo.closest('[data-mo-ys-nudge]');
        var geoFailed = function () {
          if (!fromNudge) { geo.textContent = 'Choose a showroom below'; return; }
          hideNudge();
          yourStoreOpener = visibleToggle();
          setYourStorePanel(true, yourStoreOpener);
        };
        if (!navigator.geolocation) {
          geoFailed();
          return;
        }
        var geoSurface = geo.closest('[data-mo-your-store]') ? 'header' : 'page';
        geo.textContent = 'Finding nearest showroom';
        navigator.geolocation.getCurrentPosition(function (position) {
          var key = nearestFromPoint(position.coords.latitude, position.coords.longitude, Object.keys(stores));
          if (key) {
            saveKey(key);
            applySelectedShowroom(key);
            geo.textContent = 'Using ' + stores[key].shortLabel;
            track('mo_store_selected', { mo_store: key, mo_store_method: 'location', mo_store_surface: geoSurface });
          }
        }, geoFailed, { maximumAge: 300000, timeout: 8000, enableHighAccuracy: false });
      }
    });
  }
  function init() {
    bindInteractions();
    bindYourStore();
    var urlKey = keyFromUrl();
    if (urlKey) saveKey(urlKey);
    applySelectedShowroom(preferredKey());
    autoLocate();
    if ('MutationObserver' in window && document.body) {
      new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
